<template>
  <div id="depositct" class="contentmodaldiv" data-backdrop="false">
    <div class="modaldiv">
      <div class="contentmodal animate__animated animate__bounceInDown">
        <button class="closepopup" data-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
        <div class="login">
          <div class="logopopup">
            <img src="/static/img/logo/main_logo_20221004223046.png" />
          </div>
          <h1>ฝากเงิน</h1>
          <div class="row">
            <div class="col-12 mx-auto mb-2">
              <div class="wallet3">
                <div class="boxwallet boxout">
                  <small>หากเลือก =&gt; ไม่รับโปรโมชั่น</small>
                  <small class="text-warning"
                    >( ระบบจะโยกเงินเข้าเกมส์อัตโนมัติแบบไม่รับโปรโมชั่นใดๆ
                    )</small
                  >
                  <small class="text-warning"
                    >** หากไม่เข้าเงื่อนไขของการไม่รับโปรโมชั่น,
                    ระบบจะเปลี่ยนสถานะเป็น =&gt; รับโปรโมชั่น **</small
                  >

                  <UpdateBonus></UpdateBonus>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-0 mt-4">
            <div class="col-9 p-0">
              <div id="v-pills-tabContent" class="tab-content">
                <div
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                  class="tab-pane fade active show"
                  v-for="(item, index) in ChBankAll"
                  :key="`ch-${index}`"
                >
                  <div class="griddps">
                    <div class="ingriddps">
                      <div class="iningriddps copybtn">
                        <img
                          :style="{
                            'background-color': getBankColorwithCode(
                              item.BankCode
                            ),
                            padding:
                              item.BankCode == 'co.th.truemoney.wallet'
                                ? ''
                                : '10px',
                          }"
                          v-bind:src="getBankImgwithCode(item.BankCode)"
                        />
                        <br />
                        {{ getBankName(item.BankCode) }} <br />
                        <span>{{ item.BankAccount }}</span> <br />
                        {{ item.fullName }} <br />
                        <button @click="copyBack(item.BankAccount)">
                          <i class="far fa-copy"></i> คัดลอก
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modalspanbox mt-3">
            หากลูกค้าฝากเงินสด ผ่านตู้ หรือ ช่องทางอื่น กรุณาติดต่อแอดมินทุกกรณี

            <div>
              <label
                >หากฝากเงินแล้วยังไม่เข้าภายใน 5 นาที
                กรุณาอัพสลิปที่ปุ่มด้านล่างนี้</label
              >
            </div>

            <input
              style="visibility: initial;"
              type="file"
              @change="previewFiles"
              id=""
            />
          </div>
        </div>
      </div>
      <div class="overlaymodal"></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { fetchBank } from "@/services/modules/deposit.js";
import moment from "moment";
import DepositFormAuto from "@/components/form/DepositFormAuto";
import DepositFormTrue from "@/components/form/DepositFormTrue";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import UpdateBonus from "@/components/form/UpdateBonus";
import api from "@/services/index.js";
import QrScanner from "qr-scanner";
QrScanner.WORKER_PATH = "/static/js/qr/qr-scanner-worker.min.js";

export default {
  name: "DepositForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      // deposit
      ChAuto: [],
      ChBankTrue: [],
      ChBankAll: [],
    };
  },
  components: {
    DepositFormAuto,
    DepositFormTrue,
    UpdateBonus,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function(data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },
    async copyBack(item) {
      this.$copyText(item, this.$refs.bank);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async fetchBank() {
      await fetchBank((res) => {
        if (res.status) {
          this.ChBankTrue = res.data.ChBankTrue;
          this.ChAuto = res.data.ChAuto;
          this.ChBankAll = res.data.All;
        } else {
        }
      });
    },
    async previewFiles(event) {
      var files = event.target.files || event.dataTransfer.files;
      if (!files.length) return this.$swal.fire("no files", "", "error");
      const hasName = true;
      if (hasName && files.length) {

        QrScanner.scanImage(files[0])
          .then((result) => this.PullSlip(result))
          .catch((e) => this.$swal.fire((e.message) ? e.message : e, '', "error")).catch(() => { })
          .finally(() => {

          });
      } else this.$swal.fire("no files", "", "error");
    },
    async PullSlip(result) {
      await api
        .post("/user-profile-composite/v1/topup-api/pullslip", {
          barcode: result,
        })
        .then((v) => {
          if (v.success == true) {
            this.$swal.fire("แจ้งเตือน", v.message, "success");
          } else {
            this.$swal.fire("แจ้งเตือน", v.message, "error");
          }
        })
        .catch((e) => {
          this.$swal.fire("แจ้งเตือน", v.message, "error");
        })
        .finally(() => {

        });
    },
  },
  async mounted() {
    await this.fetchBank();
    $(".overlaymodal").on("click", function() {
      $("#depositct").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/DepositForm.vue